import classNames from 'classnames';
import * as React from 'react';
import css from './PurchaseDeletableTextInput.module.scss';
import PurchaseTextInput, { TextInputType } from './PurchaseTextInput';

import deleteIcon from '../../../../../../../public/static/books/delete.png';

export interface SimulatedEvent {
  currentTarget: {
    name: string;
    value: string;
  };
}

interface Props {
  disabled?: boolean;
  type?: TextInputType;
  onChange?: (e: React.ChangeEvent<HTMLInputElement> | SimulatedEvent) => void;
  value?: string;
  name: string;
}

class PurchaseDeletableTextInput extends React.PureComponent<Props> {
  constructor(props: Props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  private handleClick() {
    const { disabled } = this.props;

    if (!disabled && this.props.onChange) {
      const simulatedEvent = {
        currentTarget: {
          name: this.props.name,
          // NOTE: Change the value of input to empty
          value: '',
        },
      };

      this.props.onChange(simulatedEvent);
    }
  }

  private handleChange(
    e: React.ChangeEvent<HTMLInputElement & HTMLTextAreaElement>,
  ) {
    const { disabled } = this.props;

    if (!disabled && this.props.onChange) {
      this.props.onChange(e);
    }
  }

  public render() {
    const { disabled, type } = this.props;
    const classes = classNames(css.PurchaseDeletableTextInput, classNames);

    return (
      <span className={classes}>
        <PurchaseTextInput
          name={this.props.name}
          value={this.props.value}
          onChange={this.handleChange}
          className={css.PurchaseDeletableTextInput__Input}
          type={type}
        />
        <button
          className={css.PurchaseDeletableTextInput__Button}
          disabled={disabled}
          onClick={this.handleClick}
        >
          <img
            className={css.PurchaseDeletableTextInput__Icon}
            src={deleteIcon}
            alt="Delete icon"
          />
        </button>
      </span>
    );
  }
}

export default PurchaseDeletableTextInput;
